import { useState, useContext } from "react";
import DestinationsContext from "../context/DestinationsContext";
import DestinationsList from "./DestinationsList";
const Destinations = () => {
  const {
    destinationsData: { destinations },
  } = useContext(DestinationsContext);

  const [state] = useState({
    heading:
      "Discover cutting-edge building and construction technologies with aesthetic structural designs",
    paragraph:
      "Global Talia Limited focuses on quality on a wide range of services/ We prioritise the satisfaction of our customers and we create edifices to taste with pride. Whenever you think of constructions with quality and class, we are the name that comes to mind. ",
  });
  return (
    <div className="destinations">
      <div className="container">
        <div className="row ml-minus-15 mr-minus-15">
          <div className="col-6 p-15">
            <h3 className="destinations__heading animation">{state.heading}</h3>
          </div>
          <div className="col-6 p-15">
            <p className="destinations__paragraph animation">
              {state.paragraph}
            </p>
          </div>
        </div>
        <div className="destinations__block">
          <div className="row ml-minus-15 mr-minus-15">
            {destinations.map((destination) => (
              <DestinationsList
                destination={destination}
                key={destination.id}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Destinations;
